"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountToPay = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../../ui");
var _utils = require("../../../../../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 6px;\n  margin: 20px 0;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiary;
}, _utils.mediaQuery.lessThan('xs')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]))));
var Title = (0, _styledComponents.default)(_ui.P)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var Currency = (0, _styledComponents.default)(_ui.H3)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 28px;\n  margin-bottom: 0;\n"])));
var AmountToPay = function AmountToPay(_ref3) {
  var amount = _ref3.amount,
    ticker = _ref3.ticker,
    text = _ref3.text,
    className = _ref3.className;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Title, null, text, ": "), /*#__PURE__*/_react.default.createElement(Currency, null, amount, " ", ticker));
};
exports.AmountToPay = AmountToPay;